import { render, staticRenderFns } from "./SectionButton.vue?vue&type=template&id=6fe83c97"
import script from "./SectionButton.vue?vue&type=script&lang=js"
export * from "./SectionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports